<template>
  <auth-layout>
    <div class="card-header justify-content-center">
      <h4 class="card-title">{{ $t("auth.signintitle") }}</h4>
    </div>
    <div v-if="!tokenInfo" class="card-body">
      <ValidationObserver v-slot="{ passes }" tag="div">
        <form
          @submit.prevent="passes(formSubmit)"
          action="otp-1"
          class="mb-3"
          novalidate=""
        >
          <ValidationProvider
            rules="required|email"
            v-slot="{ errors }"
            name="method"
            class="form-group"
            tag="div"
          >
            <label>{{ $t("auth.email") }}</label>
            <input
              type="email"
              class="form-control"
              placeholder="service.otc919@outlook.com "
              name="email"
              v-model="email"
              aria-invalid="true"
            />
            <!-- <label class="error" for="email">{{ errors[0] }}</label> -->
            <div class="invalid-feedback d-block">
              {{ errors[0] }}
            </div>
          </ValidationProvider>
          <ValidationProvider
            rules="passwordFieldName|verify_password"
            v-slot="{ errors }"
            name="password"
            class="form-group"
            tag="div"
          >
            <label>{{ $t("auth.password") }}</label>
            <input
              type="password"
              class="form-control"
              :placeholder="$t('auth.password')"
              name="password"
              v-model="password"
              aria-invalid="true"
            />
            <div class="invalid-feedback d-block">
              {{ errors[0] }}
            </div>
          </ValidationProvider>
          <div class="d-flex justify-content-between mt-4">
            <div class="input-group-form mb-0">
              <label class="toggle">
                <input class="toggle-checkbox" type="checkbox" />
                <span class="toggle-switch"></span>
                <span class="toggle-label">{{ $t("auth.rememberme") }}</span>
              </label>
            </div>
            <div class="form-group">
              <router-link
                class="text-primary"
                :to="dark ? 'reset-dark' : 'reset'"
                >{{ $t("auth.forgotpwd") }}</router-link
              >
            </div>
          </div>
          <div>
            <button
              type="submit"
              @click="login"
              :disabled="modal_loading"
              class="btn btn-success btn-block w-100"
            >
              {{ $t("auth.login") }}
            </button>
          </div>
        </form>
      </ValidationObserver>
      <div class="new-account mt-3">
        <p>
          {{ $t("auth.nothasaccount") }}
          <router-link
            class="text-primary"
            :to="dark ? 'signup-dark' : 'signup'"
            >{{ $t("auth.reg") }}</router-link
          >
        </p>
      </div>
    </div>

    <div v-if="tokenInfo" class="card-body">
      <a
        @click="
          tokenInfo = undefined;
          email = '';
          password = '';
        "
        ><span><i class="fa fa-angle-left"></i></span> Back</a
      >
      <h3 class="text-center">{{ tokenInfo.codeType }} Verification</h3>
      <p class="text-center mb-5">We will send one time code on this number</p>
      <form @submit.prevent="loginV2">
        <div class="form-group">
          <label>{{ tokenInfo.codeType }} Code</label>
          <input
            type="text"
            v-model="code"
            class="form-control text-center font-weight-bold"
            maxlength="6"
            value=""
          />
        </div>
        <div class="text-center">
          <button
            type="button"
            :disabled="modal_loading"
            class="btn btn-success btn-block"
            @click="loginV2()"
          >
            Verify
          </button>
        </div>
      </form>
      <div class="info mt-3">
        <p class="text-muted">
          You dont recommended to save password to browsers!
        </p>
      </div>
    </div>
    <!-- <b-notification :closable="false">
      <b-loading
        :is-full-page="isFullPage"
        v-model="modal_loading"
        :can-cancel="false"
      >
        <b-icon
          pack="fas"
          icon="sync-alt"
          size="is-large"
          custom-class="fa-spin"
        >
        </b-icon>
      </b-loading>
    </b-notification> -->
  </auth-layout>
</template>

<script>
import { loginV2S1, loginV2SE, baseInfo } from "../../plugins/api/user";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import store from "@/store/index";
import AuthLayout from "../../components/layouts/AuthLayout";
import { Indicator } from "mint-ui";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    AuthLayout,
  },
  data() {
    return {
      email: "",
      password: "",
      code: "",
      checkbox: "",
      dark: window.location.pathname.includes("dark"),
      modal_loading: false,
      tokenInfo: undefined,
      isLoading: false,
      isFullPage: true,
    };
  },
  mounted() {
    this.$Message.warning("Plase Login");
  },
  created() {},
  methods: {
    formSubmit() {
      this.$Loading.start();
      this.modal_loading = true;
      loginV2S1({
        account: this.email,
        password: this.password,
        checkbox: this.checkbox,
      })
        .then((res) => {
          this.tokenInfo = res;
          // this.showInputCode = true;
          this.modal_loading = false;
          this.$Loading.finish();
        })
        .catch((err) => {
          console.log(err);
          this.modal_loading = false;
        });
    },
    loginV2() {
      if (this.code.length == 6) {
      } else {
        return;
      }
      this.$Loading.start();
      this.modal_loading = true;
      let reqInfo = {
        data: { token: this.tokenInfo.token },
        validata: {},
      };
      if (this.tokenInfo.codeType == "Google") {
        reqInfo.validata.googleCode = this.code;
      } else {
        reqInfo.validata.emailCode = this.code;
      }
      loginV2SE(reqInfo)
        .then((res) => {
          this.modal_loading = false;
          // let loginUser = {};
          // loginUser.token = res.token;
          if (res.userInfo.certStatus < 0) {
            console.log(`/cert_pendding`);
            this.$router.push("/cert_pendding");
            return;
          }

          store().commit("setLogin", res);
          baseInfo().then((base_res) => {
            base_res.data.displayName = res.userInfo.realName;
            localStorage.setItem("userBaseInfo", JSON.stringify(base_res.data));
            this.$Message.success(base_res.msg);
            this.$Loading.finish();
            if (!res.userInfo.certStatus) {
              // this.$router.push("/reg/person/step1");
              this.$router.push("/changekyc");
            } else {
              this.$router.push(this.$router.currentRoute.query.to || "/");
            }
          });
        })
        .catch((err) => {
          console.log(err);
          this.modal_loading = false;
        });
    },
    login() {},
  },
};
</script>
